import styled from 'styled-components';

export const TutorialBoxContainer = styled.div`
  width: 300px;
  margin: 0;
`;

export const TutorialBoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5%;
  padding: 0 5%;
  border-bottom: 1px solid rgba(241, 241, 241, 1);
`;
export const TutorialBoxFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5%;
  padding: 5px 0;
  border-top: 1px solid rgba(241, 241, 241, 1);
`;

export const TutorialButton = styled.button`
  background: rgba(190, 214, 0, 1);
  height: 36px;
  width: 126px;
  border: none;
  margin: 0 5%;
`;

export const TutorialText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.015em;
  text-align: left;
  padding: 0 5%;
`;

export const TutorialTitle = styled.h2`
  max-width: 80%;
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.015em;
  text-align: left;
  text-transform: uppercase;
`;

export const LeftArrow = styled.div`
position: relative;
transform: rotate(30deg);
left: -10px;
top: 20px;
width: 0;
height: 0;
border-left: 10px solid transparent;
border-right: 10px solid transparent;
border-bottom: 17.32px solid #fff; 
}
`;
export const RightArrow = styled.div`
position: relative;
transform: rotate(-30deg);
left: 290px;
top: 15px;
width: 0;
height: 0;
border-left: 10px solid transparent;
border-right: 10px solid transparent;
border-bottom: 17.32px solid #fff; 
}
`;
